import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, limit, query } from 'firebase/firestore';

import { db } from '@/config';

/**
 * Czy hotel ma w ogóle skonfigurowany serwis śniadaniowy.
 *
 * Po to, żeby link „Śniadania" w menu zamówień pojawiał się tylko tam, gdzie
 * jest co pokazywać. Jednorazowy odczyt z `limit(1)` zamiast listenera — menu
 * nie musi reagować na zmiany w tej samej sekundzie, a listener w korzeniu
 * aplikacji żyłby przez całą sesję.
 */
export const useHasBreakfastService = (organizationId: string | null | undefined): boolean => {
  const { data } = useQuery({
    queryKey: ['hasBreakfastService', organizationId],
    queryFn: async () => {
      const snap = await getDocs(
        query(collection(db, `hotels/${organizationId}/breakfastService`), limit(1)),
      );
      return !snap.empty;
    },
    enabled: !!organizationId,
    staleTime: 1000 * 60 * 10,
  });

  return data === true;
};
